// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__ceETP","breadcrumb__path":"Breadcrumb_breadcrumb__path__AuJLX","breadcrumb__path__chip":"Breadcrumb_breadcrumb__path__chip__K5uSP"};